module.exports = __webpack_public_path__ + "img/fraunhofer.de30ee8d.svg";